import axios from "axios";
import { domain } from "../../Links/Links";

export async function productRequest(link, setLoadingStatus, setData, setQuantityInShoppingCart) {
    setLoadingStatus(true);

    const response = await axios.get(domain + '/product/?link=' + link , {
        withCredentials: true,
    })

    if (response.data) { 
        setLoadingStatus(false);
        setData(response.data);

        console.log(response.data)


        if (response.data[0].quantity_in_shopping_cart) {
            console.log(response.data[0].quantity_in_shopping_cart)
            setQuantityInShoppingCart(response.data[0].quantity_in_shopping_cart);
        }
    }

    
}